<template>
  <div class="l_terms_of_service">
    <div class="content">
      <div class="">
        <p>利用規約</p>
      </div>
      <div class="sub_content">
        <p>2018年08月28日制定</p>
      </div>
      <div class="sub_content">
        <p>本サービス（第1条第(1)号に定義する。以下同じ。）を利用する者は、「香の川製麺アプリ利用規約」（以下「本規約」という。）に同意の上、本サービスを利用するものとする。</p>
      </div>
       <div class="sub_content">
        <p>第1条（定義等）</p>
        <p>本規約において、次の各号に記載される用語は、それぞれ各号に記載の意味を有するものとする。</p>
        <p>(1)「本サービス」とは、「本アプリ」（本条第３号で定義する）を通じ利用者にコンテンツ（お知らせ、チラシなど）を配信するサービスをいう。</p>
        <p>(2)「利用者」とは、本サービスを利用するすべての者のことをいう。 </p>
        <p>(3)「本アプリ」とは、弊社が開発して配信するスマートフォンアプリ「香の川製麺アプリ」をいう。</p>
      </div>
      <div class="sub_content">
        <p>第2条 （本契約の成立等） </p>
        <p>1. 利用する全ての方（以下「利用者」という。）との間で適用される。 </p>
        <p>2. 利用者が本サービスを利用したことをもって、本規約に同意したものとみなす。 </p>
        <p>3. 弊社は本規約を、利用者への予告なしに改訂できるものとし、弊社が改定後の規約を本サービスに掲示することをもって、利用者は改定後の本規約に同意したとみなされるものとする。</p>
      </div>
      <div class="sub_content">
        <p>第3条 （本アプリの使用および対価等）</p>
        <p>1. 本アプリのインストール・使用・削除等ならびに本サービスの利用は、利用者の費用と責任において行うものとする。 </p>
        <p>2. 本サービスは無料で提供されるが、通信料等については利用者が負担するものとする。 </p>
        <p>3. 弊社は利用者に対して、本規約に基づき、日本国内において本アプリを利用するための非独占的かつ譲渡不可能の権利を許諾する。なお、利用者は、著作権法に定める私的使用の場合および前項の権利を行使するために必要最低限の場合をのぞき、本アプリを複製せず、公衆送信せず、頒布せず、譲渡せず、翻案せず、またはその他本サービスの趣旨に反した利用をしないものとする。 </p>
      </div>
      <div class="sub_content">
        <p>第４条（知的財産権）</p>
        <p>本サービスに掲載された記事および画像等の著作物ならびに本アプリに関する知的財産権は当社または弊社にそれらの利用許諾をする第三者に帰属するものとする。 </p>
      </div>
      <div class="sub_content">
        <p>第５条（本アプリ取得情報等）</p>
        <p>1. 本アプリ取得情報は、弊社および配信者間では、配信者に帰属するものとする。なお、配信者は、自らのプライバシーポリシーに基づき本アプリ取得情報を取得し、当該プライバシーポリシーに定める目的の範囲内に限って、これを取扱うものとするとともに、個人を特定する目的で用いないものとする。</p>
        <p>2. 本アプリ取得情報は、弊社および配信者間では、前項に加え、弊社にも帰属するものとする。弊社は、弊社ウェブサイトに掲げるプライバシーポリシーに基づき当該情報を取得し、当該プライバシーポリシーに定める目的の範囲内に限って、これを取扱うものとするとともに、個人を特定する目的で用いないものとする。 </p>
        <p>3. 配信者は、本アプリ取得情報を、配信者のマーケティング・広告宣伝活動および配信者の活動に対するお問い合わせに対する対応に用いるものとし、配信者のプライバシーポリシーに従って取り扱うものとする。 </p>
      </div>
      <div class="sub_content">
        <p>第6条 （バージョンアップ） </p>
        <p>1. 利用者は自己の費用と責任において、最新バージョンの本アプリをインストールするものとし、最新バージョンを使用しない場合、本アプリが正常に動作しない場合があることを予め承諾するものとする。 </p>
      </div>
      <div class="sub_content">
        <p>第7条 （遵守事項） </p>
        <p>1. 利用者は、次の各号に定める事項を遵守するものとする。 </p>
        <p>(1)本規約、その他弊社が定める本サービスの利用条件を遵守すること </p>
        <p>(2)本サービスの利用に際して、個人情報保護法その他の法令を遵守し、第三者の個人情報、プライバシー、人格権等を不当に侵害しないこと </p>
        <p>(3)本サービスの提供または動作を阻害する一切の行為（リバースエンジニアリング、逆コンパイル、逆アセンブル、動作を阻害する装置の使用、技術をコピーするための行為等を含む）を行わないこと </p>
        <p>(4)本サービスに付された著作権表示その他弊社が指定する表示を削除、変更しないこと </p>
        <p>(5)本規約に反する態様、商業上不合理な態様、他者の権利を侵害し、またはそのおそれのある態様その他弊社独自の判断により不適当とみなした態様で本サービスを利用しないこと </p>
        <p>(6)弊社の書面による承諾を得ずに、弊社の会社名、商標、ロゴ、サービスマーク等を利用しないこと </p>
        <p>(7)本サービスを通じて個人を特定できる情報その他弊社が指定する情報を取得・収集・保管せず、また、当該情報を弊社に取得させないこと </p>
        <p>(8)本サービスを、本サービスと競合するサービスの開発、改善等のために利用しないこと </p>
        <p>(9)弊社の機器等に不正にアクセスし、またはその利用もしくは本サービスの運用に支障を与える行為をしないこと </p>
        <p>(10)本サービスを、人の生命・身体に重大な危険性を伴う高度の安全性が要求される用途に利用しないこと </p>
        <p>(11)本サービスを公序良俗に反する態様にて利用しないこと </p>
        <p>(12)前各号に定めるほか、本サービスを法令に違反する態様にて利用しないこと </p>
        <p>(13)別途弊社が定める仕様を遵守すること </p>
        <p>2. 利用者が前各号の何れかに違反したと弊社が判断した場合、弊社は利用者への本アプリの利用許諾を終了することができるものとする。 </p>
      </div>
      <div class="sub_content">
        <p>第8条 （利用者による賠償および補償） </p>
        <p>1. 利用者が本契約に違反し、または本サービスの利用に伴う故意もしくは過失により、弊社に対して損害を与えた場合、利用者は、弊社に対して損害の賠償をする。 </p>
        <p>2. 利用者は、本サービスを利用することにより、利用者と、第三者との間において紛争が生じたときは、当該紛争が弊社の責に帰すべき事由に起因する場合を除き、本契約の有効期間中はもとより終了後に発生したものであっても、自己の責任と費用でこれを解決するものとし、弊社が損害を被った場合は、これを補償する。</p>
      </div>
      <div class="sub_content">
        <p>第9条 （責任の限定） </p>
        <p>1. 弊社は、弊社の故意または重過失による場合を除き、本サービスの利用または利用不能、その他本契約に関連して利用者に生じた一切の損害について一切責任を負わないものとする。 </p>
        <p>2. 弊社は、利用者に対して、特別な事情により生じた損害、逸失利益、利用者において代替のサービス等を利用するために要した費用、データの喪失に伴う損害について、一切責任を負わないものとする。</p>
      </div>
       <div class="sub_content">
        <p>第10条 （不可抗力免責） </p>
        <p>天災地変、戦争、内乱、テロ、暴動、停電、通信設備の事故、通信事業者の役務提供の停止または緊急メンテナンスの実施、ストライキまたはその他の労働争議、内外法令の制定・改廃、公権力による命令・処分・指導その他弊社の責に帰することのできない事由により本契約の全部または一部を履行できなかった場合、弊社はその履行できなかった範囲で責任を負わず、本契約上の義務を免除される。 </p>
       </div>
      <div class="sub_content">
        <p>第11条 （通知） </p>
        <p>本サービスに関する問い合わせその他利用者からの弊社に対する通知および本規約の変更に関する通知その他弊社からの利用者に対する通知は、弊社の指定するウェブサイト上または本アプリ内での表示など、弊社の別途定める方法により行うものとする。</p>
      </div>
      <div class="sub_content">
        <p>第12条 （本サービスの・変更、中止） </p>
        <p>1. 弊社は、本サービスの全部または一部を任意に変更・中止することができる。 </p>
        <p>但し、本サービスの終了・変更する場合は、弊社が別途定める方法で、事前に利用者に伝えるものとする。 </p>
        <p>2. 前項の中止または本サービスの変更の結果、利用者に損害が発生した場合であっても、弊社は一切責任を負わないものとする。 </p>
        <p>第13条 （準拠法および専属的合意管轄） </p>
        <p>1. 本契約については、日本法に準拠する。 </p>
        <p>2. 本契約または本サービスに関する訴訟については、東京地方裁判所を第一審の専属的合意管轄裁判所とする。 </p>
      </div>
       <div class="sub_content">
        <p>第14条 （協議事項） </p>
        <p>本契約に定めのない事項および本契約の解釈について疑義を生じた事項については、申込者および弊社は、互いに誠意をもって協議のうえ、解決を図る。</p>
      </div>
      <div class="sub_content">
        <p class="bold">Beacon Bankの利用について</p>
      </div>
      <div class="sub_content">
        <p>本アプリは、位置情報に応じたコンテンツの配信、利用状況把握によるマーケティング情報の取得・サービス改善等を目的に、以下のサービスを利用するものとする。アプリユーザーは、その利用および情報の提供を承諾するものとする。</p>
      </div>
      <div class="sub_content">
        <p>(1)本アプリにおいては、ビーコンサービスを提供するため、株式会社unerryの提供するBeacon Bankを利用している。</p>
      </div>
      <div class="sub_content">
        <p>(2)本アプリにおいては、以下の情報をBeacon Bankに提供する。</p>
        <p>①スマートフォン等の端末情報（端末機種名、端末メーカー、端末OSバージョン。）</p>
        <p>②広告識別子（IDFAまたはGoogle Advertising ID等）</p>
        <p>③スマートフォン等にかかる位置情報</p>
        <p>④アプリユーザーの取得した近傍のビーコンにかかる情報</p>
        <p>⑤本アプリの利用状況にかかる情報（位置情報利用許可の有無、Bluetoothのオン／オフ、プッシュコンテンツの閲覧・開封日時、反応したビーコンの情報を含む。）</p>
        <p>⑥本アプリの提供者が必要と判断したアプリユーザーのセグメント情報（年代、性別、職業など。ただし、個人情報を除く。）</p>
        <p>但し、②については、アプリユーザーが任意にオプトアウトすることができる。</p>
      </div>
      <div class="sub_content">
        <p>(3)株式会社unerryにおいては、本規定により取得した情報を、本アプリの提供者に対して電磁的方法または書面により提供することがあるほか、本アプリの提供者に対するそのアプリユーザーへの情報配信サービスの提供、本アプリの提供者に対するマーケティングサービス・本アプリの利用状況の統計情報の提供ならびにBeacon Bankにかかるサービスの品質の維持・向上およびマーケティングのために用いる。また、前号④の情報については、個人を特定せず、ビーコンの発するIDを特定しない状態にて、ビーコンにかかる情報を公開することがある。なお、株式会社unerryは、取得した情報を個人を特定する目的で用いないものとし、同社のプライバシーポリシー（第三者提供を停止する方法を含む。）は、同社のウェブサイトにおいて提供されており、トップページにそのリンク先が明示されている。</p>
      </div>
      <div class="sub_content">
        <p>(4)上記のほか、株式会社unerryは、その連携する本アプリの提供者または株式会社unerryが連携する事業者（広告事業社およびシステムインテグレーターを含む第三者）に対して、第(2)号に規定される情報およびこれらに係る分析情報を電磁的方法または書面により提供する可能性がある。これらのデータ提供は、オンライン広告・コンテンツの配信やその効果の測定、モバイルソリューション提供およびマーケティングを目的としてなされるものとする。</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TermsOfService'
}
</script>
<style scoped>
.l_terms_of_service{
  background-color: #ffffff;
  padding: 18px 15px;
}
.l_terms_of_service .content {
  max-height: 100%;
  text-align: left;
  font-family: HiraKakuPro-W3;
  font-size: 12px;
}

.l_terms_of_service .content .sub_content {
  padding-top: 24px;
}

.l_terms_of_service .content .sub_content .bold{
  font-weight: bold;
}

</style>
